import { defineStore } from 'pinia'
import { httpCmSyCmmCommRetrieveSysDate } from '@/service/apis/comm/cm/sy/cmm.api'
import { httpHelper } from '@/utils/helper/http.helper.js'

export const useCMSYCMMstore = defineStore({
  id: 'useCMSYCMMstore',

  state: () => ({}),

  getters: {},

  actions: {
    // 시스템날짜 조회
    async actionHttpCmSyCmmCommRetrieveSysDate() {
      try {
        const { data } = await httpHelper(httpCmSyCmmCommRetrieveSysDate)
        return data.sysDateChar14
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
})
